var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8809 19L13.8113 21.4225C13.4152 21.8075 12.5241 22 11.93 22H8.16729C6.97907 22 5.69184 21.1338 5.39479 19.9788L3.01836 12.9528C2.52327 11.6054 3.43488 11 4.92015 11H8.88086C9.47497 11 9.97006 10.5188 9.87104 9.84504L9.3555 6.21561C9.15746 5.34939 9.75157 4.38693 10.6427 4.09819C11.4349 3.80945 12.4251 4.19444 12.8211 4.77191L16.8809 11",
    stroke: "#303C54",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.8828,
    y: 7,
    width: 5,
    height: 14,
    rx: 2,
    stroke: "#303C54",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.2b9c08b5f316743148fa90c2f03a472c.svg";
export { ForwardRef as ReactComponent };